import { ChangeEvent, ReactNode } from 'react';
import pluralize from 'pluralize';
import { QuickSearchLightbox } from '../../../common/quick-search-lightbox/QuickSearchLightbox';
import { QuickSearchLightboxItem } from '../../../common/quick-search-lightbox/types';

export interface SearchLightboxProps<TData> {
  isLoading: boolean;
  searchTxt: string;
  tempSearchTxt: string;
  onSearchChange: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onKeyDown: (e: React.KeyboardEvent<HTMLDivElement>) => void;
  onClearButtonClick: () => void;
  translatedResults: QuickSearchLightboxItem<TData>[];
  defaultItems: QuickSearchLightboxItem<TData>[];
  onItemClick: (item: QuickSearchLightboxItem<TData>) => void;
  onShowAllClick: () => void;
  onClose: () => void;
  renderListElement: (item: TData) => ReactNode;
  filterComponent?: ReactNode;
}

export const SearchLightbox = <TData,>({
  isLoading,
  searchTxt,
  tempSearchTxt,
  onSearchChange,
  onKeyDown,
  onClearButtonClick,
  translatedResults,
  defaultItems,
  onItemClick,
  onShowAllClick,
  onClose,
  renderListElement,
  filterComponent,
}: SearchLightboxProps<TData>) => (
  <QuickSearchLightbox
    isOpen
    isLoading={isLoading}
    submittedInputValue={searchTxt}
    typedInputValue={tempSearchTxt}
    items={searchTxt ? translatedResults : [...defaultItems]}
    displayShowAllButton={translatedResults.length > 0}
    onSearchChange={onSearchChange}
    onKeyDown={onKeyDown}
    onClearSearchButtonClick={onClearButtonClick}
    onClose={onClose}
    onItemClick={onItemClick}
    onShowAllClick={onShowAllClick}
    renderListElement={renderListElement}
    filterComponent={filterComponent}
    listTitle={
      searchTxt
        ? `Showing ${pluralize('result', translatedResults.length, true)}`
        : 'Suggested searches'
    }
  />
);
